import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

// Framework-side client for SMS-utsendelse jobs (/api/sms/bulk). Creating a
// job is a visitor-domain call and lives in visitorStore.bulkSmsCreate.
class SmsBulkStore extends LocalModel {
    constructor() {
        super('smsBulk', {
            namePlural: 'smsBulks',
            namePluralReal: 'sms/bulk',
            sort: '-createdDate',
            limit: 20,
            api: {
                search: {
                    url: '/api/sms/bulk/',
                    params: {
                        limit: 20,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/sms/bulk/',
                    params: {},
                },
                save: {
                    url: '/api/sms/bulk/',
                    params: {},
                },
                delete: {
                    url: '/api/sms/bulk/',
                    params: {},
                },
            },
        });
    }

    @observable newSmsBulk = {};

    @observable smsBulk = {};

    @observable smsBulks = [];

    @action
    resetNewSmsBulk() {
        this.newSmsBulk = {};
    }

    async loadOne(id) {
        const response = await util.fetchApi(`/api/sms/bulk/${id}`, { method: 'GET' }, {});
        if (response.status === 200) {
            const job = Array.isArray(response.data) ? response.data[0] : response.data;
            this.updateKeyValue('smsBulk', job || {});
            return job || null;
        }
        return null;
    }

    async loadList() {
        const response = await util.fetchApi('/api/sms/bulk/', { method: 'GET' }, { limit: 20 });
        if (response.status === 200) {
            this.updateKeyValue('smsBulks', Array.isArray(response.data) ? response.data : []);
        }
        return response;
    }

    async cancel(id) {
        const response = await util.fetchApi(`/api/sms/bulk/${id}`, { method: 'PATCH' }, { status: 'cancelled' });
        if (response.status === 200) {
            const job = Array.isArray(response.data) ? response.data[0] : response.data;
            if (job) {
                this.updateKeyValue('smsBulk', job);
                this.updateKeyValue('smsBulks', this.smsBulks.map(j => (j.id === job.id ? job : j)));
            }
        }
        return response;
    }
}

const store = new SmsBulkStore();
export default store;
